import { _ as a } from "../internals/export.js";
import { g as r } from "../internals/global.js";
import { t as e } from "../internals/task.js";
var l = e.clear;
a({
  global: !0,
  bind: !0,
  enumerable: !0,
  forced: r.clearImmediate !== l
}, {
  clearImmediate: l
});